module.exports = __webpack_public_path__ + "img/media-9.2c00c5db.png";